import { getValueByKey } from "../../helper/helpers";

export const sorter = (optionLabelProp) => (option1, option2) =>
  getValueByKey(option1, optionLabelProp) >
  getValueByKey(option2, optionLabelProp)
    ? 1
    : -1;

export const filterOptions = (
  optionLabelProp,
  options = [],
  searchQuery = "",
) => {
  return options.filter((i) =>
    getValueByKey(i, optionLabelProp)
      .toString()
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );
};
